import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { reportContain } from '../../../utils/constants';
@Component({
  selector: 'app-report-comment',
  imports: [CommonModule, NgbModule, FormsModule],
  templateUrl: './report-comment.component.html',
  styleUrl: './report-comment.component.scss',
})
export class ReportCommentComponent {
  reasonSelected = 'Harassment or Bullying';
  options = reportContain;
  reason: any;

  constructor(private _activeModal: NgbActiveModal) {}

  onClose(): void {
    this._activeModal.close();
  }
  confirm() {
    let data: any = {
      reasonSelected: this.reasonSelected,
      reason: this.reason,
    };
    this._activeModal.close(data);
  }
  showSubmit(value: any) {
    if (value == '' || value == null || value == undefined) {
      return true;
    }
    const hasWhitespace = (value as string)?.trim().length === 0;

    return hasWhitespace ? true : null;
  }
}
